import {useEffect, useMemo, useState} from 'react';
import {useCanvas} from '~/common/canvas/hooks/useCanvas';
import {canvasRemoveTextBordersAndIcons} from '~/common/canvas/customs/text_border';

export const useCanvasImage = (fabricArt) => {
  const [image, setImage] = useState();
  const [loaded, setLoaded] = useState(!fabricArt);

  const {canvasInstance} = useMemo(
    () =>
      useCanvas(null, fabricArt, (canvas) => {
        canvasRemoveTextBordersAndIcons(canvas);
        setLoaded(true);
        const snapshot = canvas.toDataURL({
          enableRetinaScaling: true,
        });
        setImage(snapshot);
      }),
    [fabricArt]
  );

  useEffect(
    () => () => {
      canvasInstance.setDimensions({width: 1, height: 1});
      canvasInstance.clear();
      canvasInstance.dispose();
    },
    []
  );

  return {image, loading: !loaded};
};
